import { Collapse, Flex, Radio } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { memo } from 'react';

import { useSectionReportTypeLineItem } from './SectionReportTypeLineItem.hooks';
import { messages } from './SectionReportTypeLineItem.messages';
import { SectionReportTypeLineItemProps } from './SectionReportTypeLineItem.types';

export const SectionReportTypeLineItem = memo<SectionReportTypeLineItemProps>((props) => {
    const { reportConfig, onReportConfigChange } = props;

    const { integration, integrationTemplates, handleTemplateToggle } = useSectionReportTypeLineItem(
        reportConfig,
        onReportConfigChange
    );

    if (!integration || integrationTemplates.length === 0) {
        return null;
    }

    return (
        <Collapse
            localStorageKey='workflows-line-item'
            bordered
            radius='small'
            spacing='0 24 16 24'
            name={messages.integrationSectionTitle({
                integrationName: selectors.integration.getIntegrationTypeName(integration.integrationType),
            })}
        >
            <Radio.Group name='workflows' value={reportConfig.reportCode || ''} onChange={handleTemplateToggle}>
                <Flex direction='column' spacing='12'>
                    {integrationTemplates.map((template) => (
                        <Radio value={template.lineItemCode || ''} key={template.id}>
                            {template.text}
                        </Radio>
                    ))}
                </Flex>
            </Radio.Group>
        </Collapse>
    );
});

SectionReportTypeLineItem.displayName = 'SectionReportTypeLineItem';
